import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { formatLocalDate } from "../utils/dateUtils";

const OfferTicket = ({ promo, onBookNow, onCopy }) => {
  const discountLabel =
    promo.discount_type === "percent"
      ? `${promo.discount_value}%`
      : `₹${Math.round(promo.discount_value)}`;

  return (
    <div className="offer-ticket">
      <div className="ot-discount">
        <span className="amt">{discountLabel}</span>
        <span className="lbl">OFF</span>
      </div>
      <div className="ot-mid">
        <div className="ot-titlewrap">
          <div className="ot-title">{promo.title}</div>
          <div className="ot-desc">On bookings above ₹{Math.round(promo.min_order_value)}</div>
        </div>
        <button
          type="button"
          className="ot-code"
          onClick={() => onCopy(promo.code)}
          title="Copy code"
        >
          Use Promo Code {promo.code}
          <i className="fa fa-copy"></i>
        </button>
      </div>
      <button className="ot-cta" onClick={() => onBookNow(promo)} type="button">
        Book Now
      </button>
    </div>
  );
};

const OffersSection = ({ promos }) => {
  const navigate = useNavigate();

  if (!promos || promos.length === 0) return null; //. No render if no active featured promos

  const handleBookNow = (promo) => {
    // Same tomorrow/day-after default the other "View All" / search entry
    // points use — /stays filters everything out without a date range.
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const dayAfter = new Date();
    dayAfter.setDate(dayAfter.getDate() + 2);

    navigate("/stays", {
      state: {
        page: 1,
        limit: 10,
        checkin_date: formatLocalDate(tomorrow),
        checkout_date: formatLocalDate(dayAfter),
        adults: 1,
        kids: 0,
        rooms_required: 1,
        promo_codes: [promo.code],
      },
    });
  };

  const handleCopy = async (code) => {
    try {
      await navigator.clipboard.writeText(code);
      toast.success(`Copied "${code}" to clipboard`);
    } catch {
      toast.warn("Couldn't copy automatically — code is " + code);
    }
  };

  return (
    <section className="offerscontainer">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div
              className="section-heading"
              data-aos="zoom-in"
              data-aos-easing="ease-out-cubic"
              data-aos-duration="1000"
            >
              <h2>Offers</h2>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12" data-aos="fade-up" data-aos-duration="500">
            <div className="offer-list">
              {promos.map((promo) => (
                <OfferTicket
                  key={promo.code}
                  promo={promo}
                  onBookNow={handleBookNow}
                  onCopy={handleCopy}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OffersSection;
